import type { AccessionCaseType } from "@blis/shared/models/accession-case-type";
import {
  accessionCaseTypeLabels,
  accessionCaseTypes,
} from "@blis/shared/models/accession-case-type";

import { FieldError, Label } from "@/components/ui/field";
import {
  Select,
  SelectItem,
  SelectList,
  SelectTrigger,
} from "@/components/ui/select";

const caseTypeOptions = accessionCaseTypes.map((value) => ({
  id: value,
  label: accessionCaseTypeLabels[value],
}));

export function CaseTypeSelect({
  value,
  onChange,
  label,
  isInvalid,
  error,
}: {
  value: AccessionCaseType | null | undefined;
  onChange: (value: AccessionCaseType | null) => void;
  label?: React.ReactNode;
  isInvalid?: boolean;
  error?: string;
}) {
  return (
    <Select
      aria-label="Case type"
      className="w-fit max-w-full"
      selectedKey={value ?? null}
      onSelectionChange={(key) => {
        onChange((key as AccessionCaseType | null) ?? null);
      }}
      placeholder="Select..."
      isInvalid={isInvalid}
      validationBehavior="aria"
    >
      {label ? <Label>{label}</Label> : null}
      <SelectTrigger isClearable />
      <SelectList items={caseTypeOptions}>
        {(item) => (
          <SelectItem id={item.id} textValue={item.label}>
            {item.label}
          </SelectItem>
        )}
      </SelectList>
      <FieldError>{error}</FieldError>
    </Select>
  );
}
